import { createFileRoute } from '@tanstack/react-router'

import { validateTransactionsSearch } from '#pages/UserTransactions/search'

export const Route = createFileRoute('/_authenticated/transactions')({
  validateSearch: validateTransactionsSearch,
})
